/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */
import { saveDeclarationSectionFieldObject } from '../api/setFormData'
const initialState = {
  // initialValues
}

export default function DeclarationSectionReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_DECLARATION_SECTION': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'UPDATE_DECLARATION_SECTION_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'SAVE_DECLARATION_SECTION_FIELD': {
      saveDeclarationSectionFieldObject(action.payloadcc)
      return Object.assign({}, state)
    }
    default:
      return state
  }
}
